import React, { FunctionComponent} from 'react';
import { isEditorActive, RichText } from '@sitecore-jss/sitecore-jss-react';
import { TGalleryCarouselItemProps } from '../types/gallerycarousel.types';
import VideoPlayer from '../../@shared/videoPlayer';
import Picture from '../../@shared/picture';

const GalleryCarouselSlide: FunctionComponent<TGalleryCarouselItemProps> = ({ fields, id }) => {

  return (
    <div className={'slide__inner'}>
      {fields.useVideo?.value ? (
         <VideoPlayer link={fields?.video?.value?.href} autoPlay={true} controls={false} muted={true} extraClassName={'slide__video-wrapper'} playsInline ={true}/>
      ) : (
        <Picture
          editorialImageProps={{
            id: id,
            desktopImage: fields?.image,
            tabletImage: fields?.mobileImage,
            mobileImage: fields?.mobileImage,
            desktopTransformation: 'Size1900',
            tabletTransformation: 'Size1200',
            mobileTransformation: 'Size1200',
            style: { zIndex: isEditorActive() ? 0 : -2 },
            cssClassImageEl: 'slide__image',
          }}
        />
      )}

      <div className={'slide-footer'}>
        <RichText field={fields?.description} tag="div" className="slide-description rich-text" />
      </div>
    </div>
  );
};

export default GalleryCarouselSlide;
